
import { Vue, Component, Emit } from 'vue-property-decorator'
import { load } from 'recaptcha-v3'

@Component({})
export default class ReCaptcha extends Vue {
  @Emit() register() {}
}
